import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CentralAjuda = () => {
    const navigate = useNavigate();
    const [activeCategory, setActiveCategory] = useState('geral');
    const [openItems, setOpenItems] = useState({});

    const toggleItem = (id) => {
        setOpenItems(prev => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    // Dados do FAQ organizados por categorias
    const faqData = {
        geral: {
            title: '📋 Informações Gerais',
            items: [
                {
                    id: 'geral-1',
                    question: 'O que é a CriaApp e como funciona?',
                    answer: 'A CriaApp é uma plataforma que transforma seu site em um aplicativo nativo para Android e iOS. Nosso processo é simples: você fornece o link do seu site, personalizamos o aplicativo conforme suas necessidades, e cuidamos de toda a publicação nas lojas oficiais.'
                },
                {
                    id: 'geral-2',
                    question: 'Quanto tempo leva para ter meu aplicativo pronto?',
                    answer: 'O processo completo leva em média 7-15 dias úteis. Isso inclui desenvolvimento, testes de qualidade, submissão e aprovação nas lojas de aplicativos. Prazos podem variar conforme a complexidade do projeto.'
                },
                {
                    id: 'geral-3',
                    question: 'Preciso ter conhecimento técnico para usar a plataforma?',
                    answer: 'Não! Nossa plataforma foi desenvolvida para ser intuitiva. Você só precisa fornecer as informações básicas do seu negócio e nosso time cuida de toda a parte técnica.'
                },
                {
                    id: 'geral-4',
                    question: 'Meu site precisa atender a algum requisito específico?',
                    answer: 'Recomendamos que seu site seja responsivo (adaptável a mobile) para garantir a melhor experiência no aplicativo. Sites muito complexos ou com funcionalidades específicas podem requerer adaptações adicionais.'
                }
            ]
        },
        tecnico: {
            title: '⚙️ Aspectos Técnicos',
            items: [
                {
                    id: 'tecnico-1',
                    question: 'Quais funcionalidades posso incluir no meu aplicativo?',
                    answer: 'Oferecemos: notificações push, integração com câmera, GPS, formulários de contato, links para redes sociais, galeria de imagens, e muito mais. Funcionalidades avançadas podem ser discutidas individualmente.'
                },
                {
                    id: 'tecnico-2',
                    question: 'O aplicativo funciona offline?',
                    answer: 'O aplicativo em si funciona offline, mas o conteúdo dinâmico do seu site requer conexão com a internet. Podemos implementar cache de conteúdo para melhor experiência offline.'
                },
                {
                    id: 'tecnico-3',
                    question: 'Como são as atualizações do aplicativo?',
                    answer: 'Atualizações de conteúdo do site refletem automaticamente no app. Atualizações de funcionalidades são feitas por nossa equipe e disponibilizadas nas lojas conforme necessário.'
                },
                {
                    id: 'tecnico-4',
                    question: 'Meu aplicativo será compatível com todas as versões do Android e iOS?',
                    answer: 'Sim! Desenvolvemos para compatibilidade com versões recentes do Android (8.0+) e iOS (12+), cobrindo a grande maioria dos dispositivos em uso.'
                }
            ]
        },
        lojas: {
            title: '📱 Publicação nas Lojas',
            items: [
                {
                    id: 'lojas-1',
                    question: 'Vocês cuidam da publicação nas lojas de aplicativos?',
                    answer: 'Sim! Cuidamos de todo o processo de publicação no Google Play e App Store, incluindo preparação de assets, submissão e acompanhamento da aprovação.'
                },
                {
                    id: 'lojas-2',
                    question: 'Quais são os custos de publicação nas lojas?',
                    answer: 'Para os clientes da CriaApp, **não há custos de publicação**. Toda a abertura da conta e envio para as lojas é gerenciada por nós, sem que você precise pagar nada diretamente.'
                },
                {
                    id: 'lojas-3',
                    question: 'Quanto tempo leva para ser aprovado nas lojas?',
                    answer: 'Google Play: 1-3 dias úteis. App Store: 3-7 dias úteis. Estes prazos são estimativas das próprias lojas e podem variar.'
                },
                {
                    id: 'lojas-4',
                    question: 'Preciso fornecer alguma documentação?',
                    answer: 'Sim, para publicação na App Store é necessário ter uma Apple Developer Account. Auxiliamos em todo o processo de documentação necessária.'
                }
            ]
        },
        pagamentos: {
            title: '💳 Planos e Pagamentos',
            items: [
                {
                    id: 'pagamentos-1',
                    question: 'Quais são as formas de pagamento aceitas?',
                    answer: 'Aceitamos PIX, cartão de crédito (até 12x), boleto bancário e transferência. Empresas também podem solicitar fatura.'
                },
                {
                    id: 'pagamentos-2',
                    question: 'Existe contrato de fidelidade?',
                    answer: 'Não trabalhamos com fidelidade. Nossos planos são mensais e você pode cancelar quando quiser, sem multas ou taxas adicionais.'
                },
                {
                    id: 'pagamentos-3',
                    question: 'O que está incluído no valor mensal?',
                    answer: 'Inclui hospedagem do aplicativo, manutenção, suporte técnico, atualizações de segurança e suporte para publicação nas lojas.'
                },
                {
                    id: 'pagamentos-4',
                    question: 'Há cobrança por download ou uso do aplicativo?',
                    answer: 'Não! Cobramos apenas a mensalidade do plano escolhido. Seus usuários podem baixar e usar o aplicativo gratuitamente, sem limitações.'
                }
            ]
        },
        suporte: {
            title: '🛠️ Suporte e Manutenção',
            items: [
                {
                    id: 'suporte-1',
                    question: 'Como funciona o suporte técnico?',
                    answer: 'Oferecemos suporte por WhatsApp, email e chat em horário comercial. Resposta em até 4 horas para urgências e 24h para demandas normais.'
                },
                {
                    id: 'suporte-2',
                    question: 'Há limite de usuários ou downloads no aplicativo?',
                    answer: 'Não! Seu aplicativo pode ter quantos usuários e downloads precisar, sem custos adicionais. Nossos servidores são dimensionados para escalar conforme a demanda.'
                },
                {
                    id: 'suporte-3',
                    question: 'E se eu precisar de uma funcionalidade específica?',
                    answer: 'Desenvolvemos funcionalidades customizadas sob demanda. Entre em contato para discutirmos suas necessidades específicas e elaborarmos um orçamento.'
                },
                {
                    id: 'suporte-4',
                    question: 'Posso migrar meu aplicativo para outra plataforma no futuro?',
                    answer: 'Sim! Fornecemos todo o código fonte e documentação necessária caso queira migrar no futuro. Não travamos seus dados.'
                }
            ]
        }
    };

    const categories = [
        { id: 'geral', icon: '📋', name: 'Informações Gerais' },
        { id: 'tecnico', icon: '⚙️', name: 'Aspectos Técnicos' },
        { id: 'lojas', icon: '📱', name: 'Publicação' },
        { id: 'pagamentos', icon: '💳', name: 'Planos' },
        { id: 'suporte', icon: '🛠️', name: 'Suporte' }
    ];

    const openWhatsApp = () => {
        const phoneNumber = "5511999999999"; // ATUALIZE COM SEU NÚMERO
        const message = "Olá! Preciso de ajuda com uma dúvida específica.";
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-12">
            <div className="container mx-auto px-4 max-w-6xl">
                {/* Header */}
                <div className="text-center mb-12">
                    <button
                        onClick={() => navigate(-1)}
                        className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-6"
                    >
                        <i className="fas fa-arrow-left mr-2"></i>
                        Voltar
                    </button>

                    <h1 className="text-4xl font-bold text-gray-900 mb-4">
                        <i className="fas fa-life-ring text-purple-500 mr-3"></i>
                        Central de Ajuda
                    </h1>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                        Encontre respostas para as dúvidas mais frequentes sobre transformação de sites em aplicativos
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {/* Sidebar - Categorias */}
                    <div className="lg:col-span-1">
                        <div className="bg-white rounded-lg shadow-lg p-6 sticky top-6">
                            <h3 className="font-semibold text-gray-800 mb-4">Categorias</h3>
                            <div className="space-y-2">
                                {categories.map(category => (
                                    <button
                                        key={category.id}
                                        onClick={() => setActiveCategory(category.id)}
                                        className={`w-full text-left px-4 py-3 rounded-lg transition-all duration-200 ${activeCategory === category.id
                                                ? 'bg-purple-100 text-purple-700 border-l-4 border-purple-500'
                                                : 'text-gray-600 hover:bg-gray-100'
                                            }`}
                                    >
                                        <span className="text-lg mr-2">{category.icon}</span>
                                        {category.name}
                                    </button>
                                ))}
                            </div>

                            {/* Contato Rápido */}
                            <div className="mt-8 p-4 bg-purple-50 rounded-lg border border-purple-200">
                                <h4 className="font-semibold text-purple-800 mb-2">Não encontrou o que procura?</h4>
                                <p className="text-purple-600 text-sm mb-4">Nossa equipe está pronta para ajudar!</p>
                                <button
                                    onClick={openWhatsApp}
                                    className="w-full bg-green-500 hover:bg-green-600 text-white py-2 px-4 rounded-lg transition-colors flex items-center justify-center"
                                >
                                    <i className="fab fa-whatsapp mr-2"></i>
                                    Falar no WhatsApp
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Conteúdo Principal */}
                    <div className="lg:col-span-3">
                        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                            {/* Header da Categoria */}
                            <div className="bg-gradient-to-r from-purple-600 to-blue-500 p-6">
                                <h2 className="text-2xl font-bold text-white">
                                    {faqData[activeCategory]?.icon} {faqData[activeCategory]?.title}
                                </h2>
                            </div>

                            {/* Lista de FAQs */}
                            <div className="p-6">
                                <div className="space-y-4">
                                    {faqData[activeCategory]?.items.map(item => (
                                        <div key={item.id} className="border border-gray-200 rounded-lg">
                                            <button
                                                onClick={() => toggleItem(item.id)}
                                                className="w-full text-left p-4 flex justify-between items-center hover:bg-gray-50 transition-colors"
                                            >
                                                <span className="font-medium text-gray-800 pr-4">{item.question}</span>
                                                <i className={`fas fa-chevron-${openItems[item.id] ? 'up' : 'down'} text-purple-500`}></i>
                                            </button>

                                            {openItems[item.id] && (
                                                <div className="px-4 pb-4">
                                                    <div className="border-t border-gray-200 pt-4">
                                                        <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>

                                {/* Dica de Navegação */}
                                <div className="mt-8 p-4 bg-blue-50 rounded-lg border border-blue-200">
                                    <div className="flex items-start">
                                        <i className="fas fa-lightbulb text-blue-500 text-xl mr-3 mt-1"></i>
                                        <div>
                                            <h4 className="font-semibold text-blue-800 mb-1">Dica de Navegação</h4>
                                            <p className="text-blue-600 text-sm">
                                                Use as categorias ao lado para explorar diferentes tópicos. Se não encontrar sua resposta,
                                                entre em contato conosco pelo WhatsApp para atendimento personalizado.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Seção de Contato Adicional */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                            <div className="bg-white rounded-lg shadow-lg p-6">
                                <div className="flex items-center mb-4">
                                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                                        <i className="fas fa-envelope text-green-600 text-xl"></i>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Email</h3>
                                        <p className="text-gray-600">contato@criaapp.com.br</p>
                                    </div>
                                </div>
                                <p className="text-gray-700 text-sm">
                                    Envie suas dúvidas por email. Respondemos em até 24 horas.
                                </p>
                            </div>

                            <div className="bg-white rounded-lg shadow-lg p-6">
                                <div className="flex items-center mb-4">
                                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                                        <i className="fas fa-clock text-blue-600 text-xl"></i>
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Horário de Atendimento</h3>
                                        <p className="text-gray-600">Segunda a Sexta: 9h-18h</p>
                                    </div>
                                </div>
                                <p className="text-gray-700 text-sm">
                                    Sábados: 9h-12h. Urgências podem ser atendidas fora do horário.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CentralAjuda;